export const MY_CLINIC_GET_REQUESTED = 'MY_CLINIC_GET_REQUESTED';
export const MY_CLINIC_GET_SUCCEED = 'MY_CLINIC_GET_SUCCEED';
export const MY_CLINIC_GET_FAILED = 'MY_CLINIC_GET_FAILED';

export const CLINIC_GET_REQUESTED = 'CLINIC_GET_REQUESTED';
export const CLINIC_GET_SUCCEED = 'CLINIC_GET_SUCCEED';
export const CLINIC_GET_FAILED = 'CLINIC_GET_FAILED';

export const TO_CLINICS_GET_BY_DOCTOR_REQUESTED = 'TO_CLINICS_GET_BY_DOCTOR_REQUESTED';
export const TO_CLINICS_GET_BY_DOCTOR_SUCCEED = 'TO_CLINICS_GET_BY_DOCTOR_SUCCEED';
export const TO_CLINICS_GET_BY_DOCTOR_FAILED = 'TO_CLINICS_GET_BY_DOCTOR_FAILED';

export const CLINIC_DETAIL_GET_REQUESTED = 'CLINIC_DETAIL_GET_REQUESTED';
export const CLINIC_DETAIL_GET_SUCCEED = 'CLINIC_DETAIL_GET_SUCCEED';
export const CLINIC_DETAIL_GET_FAILED = 'CLINIC_DETAIL_GET_FAILED';

export const SET_CURRENT_CLINIC_SELECTION = 'SET_CURRENT_CLINIC_SELECTION';
